


































import Vue, { VueConstructor } from 'vue';
import {
  PageTitle,
} from '../../common/components';
import { AxiosResponse, AxiosError } from 'axios';
import {
  AttendanceInformation, CaseInformation,
} from '../../models/api-client';
import {
  CustomersInformationVm,
} from './viewModel';
import { ToastMessage } from '@/plugins/toast/models/message';
import { ErrorStatesOptions } from '@/models/errorEntities';
import services from '../../services';
import mapper from './mappers';
import OpenCasesTable from '@/views/Customer/Cases/Open/components/OpenCasesTable.vue';
import CloseCasesTable from '@/views/Customer/Cases/Close/components/CloseCasesTable.vue';
import lang from '../../common/lang/de';
import { CaseVm } from '../Customer/Cases/viewModel';
import customerMapper from '@/views/Customer/Cases/mappers';

const { UserService } = services;

export default (Vue as VueConstructor<
  Vue & {
    $refs: {};
  }
>).extend({
  name: 'SelectedGCS',
  components: {
    PageTitle,
    OpenCasesTable,
    CloseCasesTable,
  },
  data() {
    return {
      openCases: [] as CaseVm[],
      closedCases: [] as CaseVm[],
      selectedCustomerVm: mapper.createCustomerInformationVm() as CustomersInformationVm,
      dropdownTitles: [] as string[],
      panel: [true, false],
      dropdownTitlesCustomerInfo: [
        'Gewählter Kunde',
        'Rechnungsempfänger, WERBAS//KSR Vertragspartner',
      ] as string[],
      panelCustomerInfo: [true, false],
      osaRegistrationMsg: 'OSA-Registrierung NICHT vorhanden.' as string,
    };
  },
  created() {
    this.dropdownTitles.push('Laufende Support-Vorgänge');
    this.dropdownTitles.push('Kürzlich geschlossene Support-Vorgänge');
    this.initialData();
  },
  methods: {
    initialData() {
      UserService.getAllGCSCases()
        .then((result: AxiosResponse<CaseInformation[][]>) => {
          this.openCases = customerMapper.mapCaseListDtoToCaseListOpenVm(result.data[0]);
          this.closedCases = customerMapper.mapCaseListDtoToCaseListCloseVm(result.data[1]);
        }).catch((err: AxiosError) => {
          if (
            err.response !== undefined &&
              (err.response.status === 401 || err.response.status === 500)
          ) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push({ name: 'Index' });
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
    },
    expandAttendanceCase(props: any) {
      UserService.getAttendanceGCSCase(props.item.caseId).then(
        (result: AxiosResponse<AttendanceInformation[]>) => {
          let index = this.openCases.findIndex(
            selected => selected.caseId === props.item.caseId);
          if (index > -1) {
            this.openCases[index].attendance = mapper.mapAttendanceListDtoToAttendanceListVm(
              result.data);
          } else {
            index = this.closedCases.findIndex(
              selected => selected.caseId === props.item.caseId);
            this.closedCases[index].attendance = mapper.mapAttendanceListDtoToAttendanceListVm(
              result.data);
          }          
        }
      ).catch((err: AxiosError) => {
        if (
          err.response !== undefined &&
              (err.response.status === 401 || err.response.status === 500)
        ) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
    goTo() {
      this.$router.go(-1);
    },
  },
});
